// Utils
import { formatNumberToDecimal } from '@helpers/index';

/**
 * Formats a number to a string representation of a percentage.
 *
 * @function
 * @param number - The number to format as a percentage.
 * @returns The formatted percentage string.
 */
export const formatToPercentage = (number: number): string => {
  // Format the value using the `formatValue` function from the `@helpers/index` module
  const formattedValue = formatNumberToDecimal(number, 1, false);

  // Append the percentage symbol to the formatted value
  return `${formattedValue}%`;
};
